import { Box, Button, Icon, Typography } from "@outschool/backpack";
import { ActivityEnrollableTimesModal_ActivityFragment } from "@outschool/gql-frontend-generated";
import { faCalendar, faChevronRight } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { hasOneOnOneAvailabilities } from "../utils";

export default function ActivityEnrollableTimesCta({
  activityWithEnrollableTimes,
  onRequestAnotherTimeClick,
  onClickViewAvailability,
  shouldHideAlert = false,
  buttonSize = "medium",
}: {
  activityWithEnrollableTimes?: ActivityEnrollableTimesModal_ActivityFragment;
  onRequestAnotherTimeClick: () => void;
  onClickViewAvailability: (event: React.SyntheticEvent) => void;
  shouldHideAlert?: boolean;
  buttonSize?: "small" | "medium" | "large";
}) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\ctas\\ActivityEnrollableTimes",
  );

  return hasOneOnOneAvailabilities(activityWithEnrollableTimes) ? (
    <Button
      variant="contained"
      size={buttonSize}
      onClick={(e: React.SyntheticEvent<Element, Event>) =>
        onClickViewAvailability(e)
      }
    >
      {t`View Availability`}
    </Button>
  ) : (
    <>
      {!shouldHideAlert && (
        <Box flex sx={{ flexBasis: "100%" }}>
          <Typography
            sx={{
              backgroundColor: "#fffaea",
              borderColor: "warning.500",
              borderRadius: "0.25em",
              borderStyle: "solid",
              borderWidth: "1px",
              padding: "0.5em",
            }}
          >
            <Icon
              icon={faCalendar}
              color="warning"
              sx={{
                paddingRight: "0.25em",
              }}
            />
            {!!onRequestAnotherTimeClick
              ? t`Lesson available on request only.`
              : t`There are no available time slots for this class.`}
          </Typography>
        </Box>
      )}
      {!!onRequestAnotherTimeClick ? (
        <Button
          variant="contained"
          size={buttonSize}
          onClick={() => {
            onRequestAnotherTimeClick();
          }}
        >{t`Request a Meeting`}</Button>
      ) : (
        <Button
          variant="contained"
          size={buttonSize}
          disabled
          endIcon={<Icon icon={faChevronRight} />}
        >
          {t`View Availability`}
        </Button>
      )}
    </>
  );
}
